import {
  AutomationActionType,
  AutomationTaskInput
} from 'generated-graphql/types';

export const splitRulesAndActions = (
  automationTasks: AutomationTaskInput[]
): { rules: AutomationTaskInput[]; actions: AutomationTaskInput[] } => {
  const { rules, actions } = automationTasks.reduce(
    (acc, task) => {
      if (task.action.type === AutomationActionType.UpdateCandidateStatus) {
        acc.rules.push(task);
      } else {
        acc.actions.push(task);
      }
      return acc;
    },
    { rules: [] as AutomationTaskInput[], actions: [] as AutomationTaskInput[] }
  );

  return { rules, actions };
};
